import { render } from "./UiPasswordInput.vue?vue&type=template&id=05bbe124"
import script from "./UiPasswordInput.vue?vue&type=script&lang=js"
export * from "./UiPasswordInput.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__